export function heartbeat(callback, interval = 10000) {
    const intervalId = setInterval(callback, interval);

    return () => clearInterval(intervalId);
}

export default heartbeat;
